import { Component, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Role, UserDetailDto } from '@common';
import { EuiMenuItem } from '@eui/components/eui-menu';
import { EUI_LAYOUT } from '@eui/components/layout';
import { EUI_ICON } from '@eui/components/eui-icon';
import { EUI_LANGUAGE_SELECTOR } from '@eui/components/eui-language-selector';
import { EUI_USER_PROFILE } from '@eui/components/eui-user-profile';
import { I18nService, UserService } from '@eui/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Observable, tap } from 'rxjs';
import { AuthenticationService } from './shared/services/authentication.service';

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [
    AsyncPipe,
    TranslateModule,
    ...EUI_LAYOUT,
    ...EUI_ICON,
    ...EUI_LANGUAGE_SELECTOR,
    ...EUI_USER_PROFILE,
  ],
})
export class AppComponent implements OnInit {
  user$: Observable<UserDetailDto>;

  sidebarItems: EuiMenuItem[] = [];
  pdfUrl = 'assets/documents/User_s_Guide_for_NCs-en.pdf';

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly translateService: TranslateService,
    private readonly i18nService: I18nService,
    private readonly userService: UserService
  ) {}

  ngOnInit(): void {
    console.log('v1.1.1');
    this.user$ = this.authenticationService.getUserAuthenticated$().pipe(
      tap(u => {
        this.userService.init({
          userId: u?.login ?? '',
          firstName: u?.firstName ?? '',
          lastName: u?.lastName ?? '',
        });

        this.sidebarItems.push({
          label: this.translateService.instant('MENU.EVENTS_VALIDATION'),
          url: 'events-validation',
        });

        if (u?.role === Role.ECS) {
          this.sidebarItems.push({
            label: this.translateService.instant(
              'MENU.NATIONAL_COORDINATORS_MANAGEMENT'
            ),
            url: 'national-coordinators-management',
          });
          this.sidebarItems.push({
            label: this.translateService.instant(
              'MENU.EVENTS_REPORTING'
            ),
            url: 'events-reporting',
          });
        }

        this.sidebarItems.push({
          label: this.translateService.instant('MENU.USER_GUIDE'),
          urlExternal: this.pdfUrl,
        });

        this.sidebarItems.push({
          label: this.translateService.instant(
            'MENU.REPORTING_INFORMATION_SECURITY_INCIDENT'
          ),
          urlExternal:
            'https://single-market-economy.ec.europa.eu/reporting-information-security-incident_en',
        });
        if (this.sidebarItems && this.sidebarItems.length > 0) {
          this.getPdfLink(this.sidebarItems);
        }
      })
    );
  }

  getPdfLink(sidebarItems: any) {
    this.i18nService.onStateChange.subscribe(state => {
      const lang = state.activeLang;
      if (lang && sidebarItems && sidebarItems.length > 0) {
        this.sidebarItems.forEach(i => {
          if (i.label === this.translateService.instant('MENU.USER_GUIDE')) {
            // temporary comment it out multi lang pdf because new manuals is only in English JIRA issue SWECFT-96
            // i.urlExternal = `assets/documents/User_s_Guide_for_NCs-${lang}.pdf`;
            i.urlExternal = `assets/documents/User_s_Guide_for_NCs-en.pdf`;
          }
        });
      }
    });
  }

  signOut() {
    this.authenticationService.signOut();
  }
}
